import { NavigationLink } from "@/components/SideNavigation";
import { CUSTOMER_FEATURE_FLAG_NAME } from "@/global";
import { ROUTES } from "@/router/constants";
import { AccessRoleTypes, Features } from "@/router/types.ts";

const getDndDefaultDirection = (
  isFeatureEnabled: (feature: Features, roleType?: AccessRoleTypes) => boolean
): string => {
  // Default to IMPORT if user has DND access, otherwise EXPORT
  return isFeatureEnabled(Features.DND) ? "IMPORT" : "EXPORT";
};

const SIDE_NAVIGATION_TOP_LINKS = (
  isFeatureEnabled: (feature: Features, roleType?: AccessRoleTypes) => boolean,
  isCustomerFeatureFlagEnabled: (flag: string) => boolean,
  isDndVisibleForBksCustomer = false
): (NavigationLink & { isEnabled: boolean })[] => {
  const isDndLegacyEnabled = isFeatureEnabled(Features.DND_LEGACY);

  return [
    {
      name: "DASHBOARD",
      icon: "chart-bars-vertical",
      route: ROUTES.DASHBOARD,
      isEnabled: isFeatureEnabled(Features.DASHBOARD)
    },
    isCustomerFeatureFlagEnabled(CUSTOMER_FEATURE_FLAG_NAME.ENABLE_TRACK_AND_TRACE_VIEW)
      ? {
          name: "TRACK_AND_TRACE.TITLE",
          icon: "vessel-side",
          route: ROUTES.TRACK_AND_TRACE,
          isEnabled: isFeatureEnabled(Features.TRACK_AND_TRACE)
        }
      : {
          name: "SHIPMENTS",
          icon: "vessel-side",
          route: ROUTES.SHIPMENTS,
          isEnabled: isFeatureEnabled(Features.SHIPMENTS)
        },
    {
      name: "AIR_SHIPMENTS",
      icon: "airplane",
      route: ROUTES.AIR_SHIPMENTS,
      isEnabled: isFeatureEnabled(Features.AIR_SHIPMENTS)
    },
    ...(isCustomerFeatureFlagEnabled(CUSTOMER_FEATURE_FLAG_NAME.BOOKING_VOLUME_ENABLED)
      ? [
          {
            name: "BOOKINGS.NAV_TITLE",
            icon: "boxes-stacked",
            route: ROUTES.BOOKINGS,
            isEnabled: isFeatureEnabled(Features.BOOKINGS)
          }
        ]
      : []),
    ...(isDndLegacyEnabled
      ? [
          {
            name: "D&D import",
            icon: "dollar-circle",
            route: ROUTES.DND_LEGACY + "/import?tab=shipments&page=1&limit=50",
            isEnabled: isDndVisibleForBksCustomer
          }
        ]
      : [
          {
            name: "D&D",
            icon: "dollar-circle",
            route: ROUTES.DND + `?direction=${getDndDefaultDirection(isFeatureEnabled)}&page=1&limit=50&view=table`,
            isEnabled: isDndVisibleForBksCustomer
          }
        ]),
    ...(isFeatureEnabled(Features.INVOICE_AUDIT)
      ? [
          {
            name: "Invoice Audit",
            icon: "receipt",
            route: ROUTES.INVOICE_AUDIT,
            isEnabled: true
          }
        ]
      : []),
    {
      name: "PORT_CONGESTION",
      icon: "crane",
      route: ROUTES.PORT_CONGESTION,
      isEnabled: isFeatureEnabled(Features.PORT_CONGESTION)
    },
    {
      name: "EMISSIONS",
      icon: "globe",
      route: ROUTES.EMISSIONS,
      isEnabled: isFeatureEnabled(Features.EMISSIONS),
      videoUrl: "https://www.youtube.com/watch?v=FK22feOK1Ik"
    },
    {
      name: "MAERSK_RISK_MANAGEMENT",
      icon: "emergency-light",
      route: ROUTES.RISK_MANAGEMENT,
      isEnabled: isFeatureEnabled(Features.RISK_MANAGEMENT),
      videoUrl: "https://www.youtube.com/watch?v=lsBC78pU5BI"
    },
    {
      name: "CARRIER_PERFORMANCE.TITLE",
      icon: "chart-line-up",
      route: ROUTES.CARRIER_PERFORMANCE,
      isEnabled: isFeatureEnabled(Features.CARRIER_PERFORMANCE)
    },
    {
      name: "REPORTING",
      icon: "clipboard-list-text",
      route: ROUTES.REPORTING,
      isEnabled: isCustomerFeatureFlagEnabled(CUSTOMER_FEATURE_FLAG_NAME.ENABLE_CENTRALISED_REPORTING)
    }
  ];
};

export { SIDE_NAVIGATION_TOP_LINKS };
